import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import StatsBand from "@/components/site/StatsBand";
import BrandsMarquee from "@/components/site/BrandsMarquee";
import TrustBar from "@/components/site/TrustBar";
import WhyUs from "@/components/site/WhyUs";
import Services from "@/components/site/Services";
import HowItWorks from "@/components/site/HowItWorks";
import Gallery from "@/components/site/Gallery";
import Videos from "@/components/site/Videos";
import WhenWorksBest from "@/components/site/WhenWorksBest";
import Reviews from "@/components/site/Reviews";
import Location from "@/components/site/Location";
import FAQ from "@/components/site/FAQ";
import QuoteForm from "@/components/site/QuoteForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyButtons from "@/components/site/StickyButtons";

const Home = () => {
  return (
    <main className="min-h-screen bg-[#0a0a0a] text-white" data-testid="home-page">
      <Header />
      <Hero />
      <StatsBand />
      <BrandsMarquee />
      <TrustBar />
      <WhyUs />
      <Services />
      <HowItWorks />
      <Gallery />
      <Videos />
      <WhenWorksBest />
      <Reviews />
      <Location />
      <FAQ />
      <QuoteForm />
      <Contact />
      <Footer />
      <StickyButtons />
    </main>
  );
};

export default Home;
